
import { Component, Vue } from 'vue-property-decorator';
import WidgetCurrentDayJobList from './components/WidgetCurrentDayJobList.vue';
import WidgetCurrentDayJobMap from './components/WidgetCurrentDayJobMap.vue';

@Component({
  components: {
    WidgetCurrentDayJobList,
    WidgetCurrentDayJobMap
  }
})
export default class Dashboard extends Vue {

}
